import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import { HelmetProvider } from "react-helmet-async"
import { AuthProvider } from "./context/AuthContext"
import { lazy, Suspense } from "react"

const Landing = lazy(() => import("./pages/Landing"))
const About = lazy(() => import("./pages/About"))
const Dashboard = lazy(() => import("./pages/Dashboard"))
const ConnectBank = lazy(() => import("./pages/ConnectBank"))
const Billing = lazy(() => import("./pages/Billing"))
const Contact = lazy(() => import("./pages/Contact"))
const Login = lazy(() => import("./pages/Login"))
const Signup = lazy(() => import("./pages/Signup"))
const Privacy = lazy(() => import("./pages/Privacy"))
const SecurityPolicy = lazy(() => import("./pages/SecurityPolicy"))
const Terms = lazy(() => import("./pages/Terms"))
const DataRetention = lazy(() => import("./pages/DataRetention"))
const MFASetup = lazy(() => import("./pages/MFASetup"))
const MFAChallenge = lazy(() => import("./pages/MFAChallenge"))
const FAQ = lazy(() => import("./pages/FAQ"))
const CaliforniaPrivacy = lazy(() => import("./pages/CaliforniaPrivacy"))
const Accessibility = lazy(() => import("./pages/Accessibility"))

function PageLoader() {
  return (
    <div className="min-h-screen bg-[#071510] flex items-center justify-center">
      <div className="w-8 h-8 rounded-full border-2 border-gold/30 border-t-gold animate-spin" />
    </div>
  )
}

export default function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <AuthProvider>
        <Suspense fallback={<PageLoader />}>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/about" element={<About />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/connect-bank" element={<ConnectBank />} />
            <Route path="/billing" element={<Billing />} />
            <Route path="/settings" element={<Navigate to="/dashboard" replace />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/security-policy" element={<SecurityPolicy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/data-retention" element={<DataRetention />} />
            <Route path="/mfa-setup" element={<MFASetup />} />
            <Route path="/mfa-challenge" element={<MFAChallenge />} />
            <Route path="/faq" element={<FAQ />} />
            <Route path="/california-privacy" element={<CaliforniaPrivacy />} />
            <Route path="/accessibility" element={<Accessibility />} />
          </Routes>
        </Suspense>
      </AuthProvider>
    </BrowserRouter>
    </HelmetProvider>
  )
}
